<template>
  <DpplTooltip
    tooltip-placement="bottom-start"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <div
        class="internal-pill"
        :class="{ 'primary-color': isPrimaryColor }"
        v-bind="$attrs"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        {{ badgeText }}
      </div>
    </template>
    <template #tooltip-content>
      <div>
        <p class="text-h2 mb-4">
          <slot name="title" />
        </p>
        <p>
          <slot name="text" />
        </p>
      </div>
    </template>
  </DpplTooltip>
</template>

<script>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

export default {
  name: 'JobBadge',
  components: { DpplTooltip },
  inheritAttrs: false,
  props: {
    badgeText: { type: String, default: '' },
    isPrimaryColor: { type: Boolean, default: false },
  },
};
</script>

<style lang="less" scoped>
.internal-pill {
  background-color: @white;
  border: 1px solid @grey-900;
  color: @text-darkest;
  font-size: 12px;
  font-weight: 500;
  padding: 0 8px;
  border-radius: 16px;
  letter-spacing: 0.75px;
  display: inline-block;

  &.primary-color {
    border-color: @text-brand;
    color: @text-brand;
  }
}
</style>
